import { Component } from "react";
import { connect } from "react-redux";
import { accept_feature } from "../../App/actions/layerNewActions";

class ModalValidasi extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClick = () => {
    const { modal_data } = this.props;
    let { layer_id } = this.props.layer;

    const body = {
      geo_layer_id: layer_id,
      feature_key: modal_data.key,
    };

    this.props.accept_feature(body);
  };

  render() {
    return (
      <div className="modal_validasi">
        <h1 style={{ fontWeight: "600" }}>
          Are you sure you want to validate this form?
        </h1>
        <button
          className="button background_black"
          id="green"
          onClick={() => this.handleClick()}
        >
          Confirm
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  layer: state.layer,
  auth: state.auth,
});

export default connect(mapStateToProps, { accept_feature })(ModalValidasi);
